(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dm-final-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.dm-final[data-event-date]').forEach(function (el) {
      var dateStr = el.getAttribute('data-event-date');
      if (!dateStr) return;
      var target = new Date(dateStr).getTime();
      if (isNaN(target)) return;
      var dEl = el.querySelector('[data-dm-days]');
      var hEl = el.querySelector('[data-dm-hours]');
      var mEl = el.querySelector('[data-dm-minutes]');
      var sEl = el.querySelector('[data-dm-seconds]');
      if (!dEl || !hEl || !mEl || !sEl) return;
      function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { dEl.textContent = '00'; hEl.textContent = '00'; mEl.textContent = '00'; sEl.textContent = '00'; return; }
        dEl.textContent = pad(Math.floor(diff / 86400000));
        hEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
        sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
      }
      tick();
      setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dm-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.dm-hero[data-event-date]').forEach(function (el) {
      var dateStr = el.getAttribute('data-event-date');
      if (!dateStr) return;
      var target = new Date(dateStr).getTime();
      if (isNaN(target)) return;
      var dEl = el.querySelector('[data-dm-days]');
      var hEl = el.querySelector('[data-dm-hours]');
      var mEl = el.querySelector('[data-dm-minutes]');
      var sEl = el.querySelector('[data-dm-seconds]');
      if (!dEl || !hEl || !mEl || !sEl) return;
      function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) { dEl.textContent = '00'; hEl.textContent = '00'; mEl.textContent = '00'; sEl.textContent = '00'; return; }
        dEl.textContent = pad(Math.floor(diff / 86400000));
        hEl.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        mEl.textContent = pad(Math.floor((diff % 3600000) / 60000));
        sEl.textContent = pad(Math.floor((diff % 60000) / 1000));
      }
      tick();
      setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-balance-promo-cro"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const gallery = root.querySelector('.bcp-slides');
    const slides = [...root.querySelectorAll('.bcp-slide')];
    const thumbs = [...root.querySelectorAll('[data-slide]')];
    let index = 0;
    const move = n => { index = Math.max(0, Math.min(slides.length - 1, n)); gallery.scrollTo({ left: index * gallery.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' }); };
    root.querySelector('[data-prev]').addEventListener('click', () => move(index - 1));
    root.querySelector('[data-next]').addEventListener('click', () => move(index + 1));
    thumbs.forEach((el, n) => el.addEventListener('click', () => move(n)));
    gallery.addEventListener('scroll', () => { index = Math.round(gallery.scrollLeft / gallery.clientWidth); root.querySelector('[data-counter]').textContent = (index + 1) + ' / ' + slides.length; thumbs.forEach((el, n) => el.setAttribute('aria-pressed', String(n === index))); }, { passive: true });
    gallery.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); move(index + (e.key === 'ArrowRight' ? 1 : -1)); } });
    const form = root.querySelector('form');
    const sticky = root.querySelector('[data-sticky]');
    const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; }, { threshold: 0.1 });
    observer.observe(form);
    const checkExpiry = () => { if (root.dataset.promo === 'true' && Date.now() >= Date.parse(root.dataset.end)) { root.dataset.promo = 'false'; root.querySelectorAll('[data-price]').forEach(el => el.textContent = root.dataset.base); root.querySelectorAll('[data-promo-only]').forEach(el => el.hidden = true); root.querySelector('[data-offer-note]').textContent = root.dataset.expired; form.querySelector('[name=discount]')?.remove(); } };
    checkExpiry();
    const timer = setInterval(() => { if (!root.isConnected) { clearInterval(timer); observer.disconnect(); } else checkExpiry(); }, 30000);
    let busy = false;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      if (busy) return;
      checkExpiry(); busy = true;
      const buttons = [...root.querySelectorAll('button[type=submit]')];
      const original = buttons.map(b => b.innerHTML);
      const error = root.querySelector('.bcp-error'); error.hidden = true;
      buttons.forEach(b => { b.disabled = true; b.textContent = root.dataset.busy; b.setAttribute('aria-busy','true'); });
      const base = window.Shopify?.routes?.root || '/';
      try {
        const body = new FormData(form);
        body.delete('return_to'); body.delete('discount');
        const response = await fetch(base + 'cart/add.js', { method: 'POST', body, headers: { Accept: 'application/json' } });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.error);
        window.location.assign(root.dataset.promo === 'true' ? base + 'discount/BalWell273792?redirect=' + encodeURIComponent(base + 'cart') : base + 'cart');
      } catch (err) {
        error.textContent = err.message || root.dataset.error; error.hidden = false;
        buttons.forEach((b,i) => { b.disabled = false; b.innerHTML = original[i]; b.removeAttribute('aria-busy'); }); busy = false;
        error.scrollIntoView({ block: 'center' });
      }
    });
  };
  document.querySelectorAll('[data-balance-promo]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-balance-promo]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-colors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sections = document.querySelectorAll('[data-wb-colors]');
    sections.forEach(function (section) {
      const slides = section.querySelectorAll('[data-wb-color-slide]');
      const dots   = section.querySelectorAll('[data-wb-color-pick]');
      const nameEl = section.querySelector('[data-wb-color-name]');
      const descEl = section.querySelector('[data-wb-color-desc]');
      if (!slides.length || !dots.length) return;

      function broadcast(dot) {
        if (!dot) return;
        const detail = {
          name: dot.dataset.name || '',
          desc: dot.dataset.desc || '',
          hex: dot.dataset.hex || '',
          variantId: dot.dataset.variant || ''
        };
        window.dispatchEvent(new CustomEvent('wb-color-change', { detail: detail }));
      }

      function activate(idx, opts) {
        opts = opts || {};
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
          d.setAttribute('aria-checked', i === idx ? 'true' : 'false');
        });
        const dot = dots[idx];
        if (dot) {
          if (nameEl) nameEl.textContent = dot.dataset.name || '';
          if (descEl) descEl.textContent = dot.dataset.desc || '';
          if (!opts.silent) broadcast(dot);
        }
      }

      dots.forEach(function (dot, idx) {
        dot.addEventListener('click', function () { activate(idx); });
        dot.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            e.preventDefault();
            const next = (idx + 1) % dots.length; dots[next].focus(); activate(next);
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            e.preventDefault();
            const prev = (idx - 1 + dots.length) % dots.length; dots[prev].focus(); activate(prev);
          }
        });
      });

      // Anuncia el color por defecto al cargar para que preventa + sticky usen su variante
      requestAnimationFrame(function () { broadcast(dots[0]); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const wrappers = document.querySelectorAll('.wb-hero[data-event-date]');
    wrappers.forEach(function (wrap) {
      const dateStr = wrap.getAttribute('data-event-date');
      if (!dateStr) return;
      const target = new Date(dateStr).getTime();
      if (isNaN(target)) return;
      const dEl = wrap.querySelector('[data-wb-days]');
      const hEl = wrap.querySelector('[data-wb-hours]');
      const mEl = wrap.querySelector('[data-wb-minutes]');
      const sEl = wrap.querySelector('[data-wb-seconds]');
      if (!dEl || !hEl || !mEl || !sEl) return;
      function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }
      function tick() {
        const diff = target - Date.now();
        if (diff <= 0) {
          dEl.textContent = '00'; hEl.textContent = '00'; mEl.textContent = '00'; sEl.textContent = '00';
          return;
        }
        const d = Math.floor(diff / 86400000);
        const h = Math.floor((diff % 86400000) / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        const s = Math.floor((diff % 60000) / 1000);
        dEl.textContent = pad(d); hEl.textContent = pad(h); mEl.textContent = pad(m); sEl.textContent = pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-preventa"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function applyColor(detail) {
      if (!detail) return;
      // Actualiza la lectura de color en preventa
      document.querySelectorAll('[data-wb-color-display]').forEach(function (el) {
        if (detail.name) el.textContent = detail.name;
      });
      document.querySelectorAll('[data-wb-color-dot]').forEach(function (el) {
        if (detail.hex) el.style.background = detail.hex;
      });
      // Inyecta variant id en TODOS los formularios de compra
      if (detail.variantId) {
        document.querySelectorAll('[data-wb-buy-form] [data-wb-variant-input]').forEach(function (input) {
          input.value = detail.variantId;
        });
      }
      // Marca el thumb activo en la propia preventa
      document.querySelectorAll('.wb-pre__colors .wb-pre__color').forEach(function (btn) {
        const match =
          (detail.variantId && btn.dataset.variant === detail.variantId) ||
          (!detail.variantId && detail.name && btn.dataset.name === detail.name);
        btn.classList.toggle('is-active', !!match);
        btn.setAttribute('aria-checked', match ? 'true' : 'false');
      });
    }
    window.addEventListener('wb-color-change', function (e) { applyColor(e.detail); });

    // Click en los thumbnails locales → emite el mismo evento
    document.querySelectorAll('.wb-pre__colors .wb-pre__color').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.dispatchEvent(new CustomEvent('wb-color-change', { detail: {
          name: btn.dataset.name || '',
          desc: btn.dataset.desc || '',
          hex:  btn.dataset.hex  || '',
          variantId: btn.dataset.variant || ''
        }}));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-stickybar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bar = document.querySelector('[data-wb-sticky]');
    if (!bar) return;

    /* === Selector de color local en la sticky === */
    const dots = bar.querySelectorAll('[data-wb-color-pick]');
    const nameEl = bar.querySelector('[data-wb-color-display]');
    function setActive(idx, broadcast) {
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.setAttribute('aria-checked', i === idx ? 'true' : 'false');
      });
      const dot = dots[idx];
      if (!dot) return;
      if (nameEl && dot.dataset.name) nameEl.textContent = dot.dataset.name;
      if (broadcast) {
        window.dispatchEvent(new CustomEvent('wb-color-change', { detail: {
          name: dot.dataset.name || '',
          desc: dot.dataset.desc || '',
          hex:  dot.dataset.hex  || '',
          variantId: dot.dataset.variant || ''
        }}));
      }
    }
    dots.forEach(function (dot, idx) {
      dot.addEventListener('click', function () { setActive(idx, true); });
    });

    /* Sincroniza la sticky cuando la sección de colores principal emite el evento */
    window.addEventListener('wb-color-change', function (e) {
      if (!e.detail) return;
      // encuentra el dot que corresponde
      let matchIdx = -1;
      dots.forEach(function (d, i) {
        if (e.detail.variantId && d.dataset.variant === e.detail.variantId) matchIdx = i;
        else if (!e.detail.variantId && e.detail.name && d.dataset.name === e.detail.name) matchIdx = i;
      });
      if (matchIdx >= 0) setActive(matchIdx, false); // sin re-broadcast (evita loop)
      else if (nameEl && e.detail.name) nameEl.textContent = e.detail.name;
    });

    /* === Visibilidad por scroll === */
    if (!('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }

    const hero  = document.querySelector('.wb-hero');
    const preventas = document.querySelectorAll('.wb-pre, .wb-section--preventa');

    let pastHero = !hero;
    let onPreventa = false;
    const sync = () => bar.classList.toggle('is-visible', pastHero && !onPreventa);

    if (hero) {
      new IntersectionObserver(([e]) => { pastHero = !e.isIntersecting; sync(); }, { threshold: 0 }).observe(hero);
    }
    if (preventas.length) {
      const ioP = new IntersectionObserver((entries) => {
        onPreventa = entries.some(e => e.isIntersecting);
        sync();
      }, { threshold: 0.30 });
      preventas.forEach(el => ioP.observe(el));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wb-waitlist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const forms = document.querySelectorAll('[data-wb-form]');
    forms.forEach(function (form) {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();
        const status = form.querySelector('[data-wb-status]');
        const submitLabel = form.querySelector('[data-wb-submit-label]');
        const submitBtn = form.querySelector('[type="submit"]');
        const success = form.parentElement.querySelector('[data-wb-success]');
        status.textContent = '';

        const companyId = form.dataset.companyId;
        const listId = form.dataset.listId;
        if (!companyId || !listId) {
          status.textContent = 'Configuración del formulario incompleta.';
          return;
        }

        const fd = new FormData(form);
        const email = (fd.get('email') || '').toString().trim();
        const name = (fd.get('name') || '').toString().trim();
        const city = (fd.get('city') || '').toString().trim();
        const wearable = (fd.get('wearable') || '').toString().trim();
        const consent = fd.get('consent');
        const smsOptin = !!fd.get('sms');
        const priorities = fd.getAll('priority');

        if (!email || !name || !city) {
          status.textContent = 'Completa nombre, email y ciudad.';
          return;
        }
        if (!consent) {
          status.textContent = 'Debes aceptar recibir comunicaciones para entrar en la waitlist.';
          return;
        }

        form.classList.add('is-loading');
        const originalLabel = submitLabel.textContent;
        submitLabel.textContent = 'Enviando…';
        submitBtn.disabled = true;

        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.dataset.customSource || 'Wellbeinn Band Landing',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    first_name: name,
                    location: { city: city },
                    properties: {
                      'Wellbeinn Priority': priorities,
                      'Current Wearable': wearable || 'No indicado',
                      'Signup Source': 'wellbeinn-band-landing',
                      'SMS Optin': smsOptin
                    }
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: listId } }
            }
          }
        };

        try {
          const res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              'revision': '2024-10-15'
            },
            body: JSON.stringify(payload)
          });

          if (res.status === 202 || res.ok) {
            form.hidden = true;
            if (success) success.hidden = false;
            try { if (window._learnq) window._learnq.push(['identify', { $email: email, $first_name: name }]); } catch (_) {}
          } else {
            const body = await res.text();
            console.warn('Klaviyo subscribe error', res.status, body);
            status.textContent = 'No hemos podido procesar tu alta. Revisa el email o inténtalo en unos minutos.';
          }
        } catch (err) {
          console.error(err);
          status.textContent = 'Error de conexión. Vuelve a intentarlo.';
        } finally {
          form.classList.remove('is-loading');
          submitLabel.textContent = originalLabel;
          submitBtn.disabled = false;
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
